
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkTimerecord } from '../models/work-timerecord';

export function getCreateTimerecorddetailDtoFormGroup() {
return new FormGroup({
    timerecordtypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    timerecordId: new FormControl<number | undefined>(undefined, [Validators.required]),
    timerecord: new FormControl<WorkTimerecord | undefined>(undefined, [Validators.required]),
    projectId: new FormControl<number | undefined>(undefined),
    hours: new FormControl<number | undefined>(undefined),
    timeStart: new FormControl<string | undefined>(undefined),
    timeEnd: new FormControl<string | undefined>(undefined),
    locked: new FormControl<boolean | undefined>(undefined),
    verified: new FormControl<boolean | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
})
;
}
      